import './App.css';
import { Routes, Route } from 'react-router-dom';
import Home from './components/Home/Home';
import PrivacyPolicy from './components/PrivacyPolicy/PrivacyPolicy';
import MerchantTerms from './components/MerchantTerms/MerchantTerms';
import PricingCalculator from './components/Pricing/PricingCalculator';

export const SIGNUP_FORM_LINK =
  'https://2fdzq6.share-eu1.hsforms.com/2pm4BhnAMQDSLDUgaF_OnAg';

function App() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/terms/privacy" element={<PrivacyPolicy />} />
      <Route path="/terms/merchant" element={<MerchantTerms />} />
      <Route path="/pricing-calculator" element={<PricingCalculator />} />
    </Routes>
  );
}

export default App;
